import styled from 'styled-components';

export const Frame = styled.div<{ $scale: number; $designHeight: number }>`
  position: relative;
  width: 100%;
  height: ${({ $designHeight, $scale }) => $designHeight * $scale}px;
  overflow: hidden;
`;

export const Stage = styled.div<{
  $scale: number;
  $designWidth: number;
  $designHeight: number;
}>`
  position: absolute;
  top: 0;
  left: 50%;
  width: ${({ $designWidth }) => $designWidth}px;
  height: ${({ $designHeight }) => $designHeight}px;
  margin-left: ${({ $designWidth }) => -$designWidth / 2}px;
  transform: scale(${({ $scale }) => $scale});
  transform-origin: top center;
`;
